import React from 'react';

import styled from 'styled-components';

import { Box } from '@adsk/alloy-react-box';
import HighlightText from '@adsk/alloy-react-highlight-text';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import MalwareContent from './MalwareContent';
import { useTranslation } from '../i18n';

const disabledTextStyle = { color: theme.colors.charcoal500 };

const fitContentTargetProps = () => ({
  style: { width: 'fit-content' },
});

const MalwareTitleWrapper = styled(Box)`
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const MalwareTooltipCell = ({ rowData, disabled, placement }) => {
  const { t } = useTranslation();
  return (
    <MalwareContent>
      <Tooltip
        content={t('MALWARE_DETECTED_TOOLTIP')}
        placement={placement}
        getTargetProps={fitContentTargetProps}
      >
        <MalwareTitleWrapper>
          <HighlightText
            matched={rowData.highlight}
            text={rowData.title}
            style={disabled ? disabledTextStyle : undefined}
          />
        </MalwareTitleWrapper>
      </Tooltip>
    </MalwareContent>
  );
};

export default MalwareTooltipCell;
